import React from "react";

// reactstrap components
import {
  Card,
  CardHeader,
  CardBody,
  NavItem,
  NavLink,
  Nav,
  TabContent,
  TabPane,
  Container,
  Row,
  Col
} from "reactstrap";

// core components

function About() {
  const [iconPills, setIconPills] = React.useState("1");
  //const [pills, setPills] = React.useState("1");
  return (
    <>
      <div className="section section-tabs" id="about">
        <Container>
          <Row>
            <Col className="ml-auto mr-auto" md="10" xl="6">
              <p className="category">About Us</p>
              <Card>
                <CardHeader>
                  <Nav className="justify-content-center" role="tablist" tabs>
                    <NavItem>
                      <NavLink
                        className={iconPills === "1" ? "active" : ""}
                        href="#pablo"
                        onClick={e => {
                          e.preventDefault();
                          setIconPills("1");
                        }}
                      >
                        <i className="now-ui-icons business_badge"></i>
                        Experience
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={iconPills === "2" ? "active" : ""}
                        href="#pablo"
                        onClick={e => {
                          e.preventDefault();
                          setIconPills("2");
                        }}
                      >
                        <i className="now-ui-icons business_briefcase-24"></i>
                        Insured
                      </NavLink>
                    </NavItem>
                    
                  
                  </Nav>
                </CardHeader>
                <CardBody>
                  <TabContent
                    className="text-center"
                    activeTab={"iconPills" + iconPills}
                  >
                    <TabPane tabId="iconPills1">
                      <p>
                      I'm Julio Rodriguez, president of <strong>SGA Remodeling Corporation</strong>, with more than 20 years of experience
                      in remodeling, from layouts, framing, drywall, to top level 5 finishes and paints.
                      We characterize ourselves for making all kinds of soffit designs in lobbies, apartments and houses.
                      </p>
                    </TabPane>
                    <TabPane tabId="iconPills2">
                      <p>
                        <strong>Yes!! we are insured</strong> under Worker's Compensation & Liability Insurance covering Broward and Dade County, 
                        our personnel is available for any job at any time.
                      </p>
                    </TabPane>
                    
                  </TabContent>
                </CardBody>
              </Card>
            </Col>

          </Row>
        </Container>
      </div>
    </>
  );
}

export default About;
